var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"buttonRoot",staticClass:"controls-footer-buttonborder",style:(_vm.buttonPadding)},[_c('v-btn',{staticClass:"controls-footer-button",attrs:{"fab":"","dark":"","small":_vm.small,"large":_vm.large,"color":_vm.color},on:{"click":_vm.clickHandler}},[_c('v-icon',{staticClass:"button-icon"},[_vm._v(_vm._s(_vm.icon))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }